import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BottomNav from "../../../../containers/BottomNav";
// import { altGaming } from "../../../../lib/data/altGaming.data";
import { turboGames } from "../../../../lib/data/turboGames.data";
import BackIcon from "../../../../assets/svg/BackIcon";

const TurboGames = () => {
  const navigate = useNavigate();

  // Collect all games from all categories in turboGames
  const allGames = Object.values(turboGames).flatMap((category) =>
    Object.values(category)
  );

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page">
          <div className="heading mt-4">
            <h2 className="sectionTitle">Turbo Games</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          {/* GAMES LIST */}
          <ul className="gamelisting mt-4">
            {allGames.length > 0 ? (
              allGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.href}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available.</p>
            )}
          </ul>
        </div>
      </main>

      <BottomNav />
    </>
  );
};

export default TurboGames;
